export interface LanguageParameters {
    language: string;
}

export function languageFilter(param: LanguageParameters) {
    if (navigator.language) {
        let navigatorFinal: string = navigator.language;
        if (navigatorFinal.indexOf(param.language) == 0) {
            return true;
        }
    } else if (navigator.language) {
        let navigatorFinal = navigator.language;
        if (navigatorFinal.indexOf(param.language) == 0) return true;
        return true;
    }
    return false;
}
